export const MAIN_ROUTE = '/main';

export const SHOW_BOTTOM_NAVBAR_ROUTES = [];
